<template>
    <div class="hts-notification-item">
        <div
            class="hts-notification-item__card"
            :class="getRead() ? 'bg-[#FFF8EA]' : 'bg-white'"
            @click="clickNotify">
            <div class="hts-notification-item__card-body">
                <h3 class="hts-notification-item__card-title">
                    {{ props.title }}
                </h3>
                <hts-avatar
                    v-if="!isAdmin"
                    :user="props.user"
                    size="large" />
            </div>
            <div class="hts-notification-item__card-message">
                {{ props.message }}
                <p
                    v-if="props.parentMessage"
                    class="text-cyan-500">
                    {{ props.parentMessage }}
                </p>
            </div>
            <div class="hts-notification-item__card-date">
                {{ timestamp }}
            </div>
        </div>
        <button
            class="hts-notification-item__icon"
            type="button"
            @click="onHandleRead">
            <hi-bell-slash-icon
                v-if="getRead()"
                class="w-6 h-6" />
        </button>
    </div>
</template>
<script lang="ts" setup>
const { $formatters } = useNuxtApp()
const emits = defineEmits(['update', 'close'])
const props = defineProps({
  title: {
    type: String,
    required: true
  },
  message: {
    type: String,
    required: true
  },
  subContent: {
    type: String
  },
  parentMessage: {
    type: String
  },
  date: {
    type: String,
    required: true
  },
  read: {
    type: Boolean,
    default: false,
    required: true
  },
  user: {
    type: String,
    required: true
  },
  url: {
    type: String,
    default: ''
  },
  query: {
    type: Object,
    default: () => {}
  },
  avatar: {
    type: String,
    default: ''
  },
  isAdmin: {
    type: Boolean,
    default: false
  }
})

const { url, query } = toRefs(props)

const getRead = () => {
  return !props.read
}

const timestamp = ref('')

const changeTime = () => {
  if (props.date) {
    timestamp.value = $formatters.dateTimeFromNow(props.date)
  }
}

let getTimestamp: any

onMounted(() => {
  getTimestamp = setInterval(changeTime, 1000)
})

onUnmounted(() => {
  getTimestamp && clearInterval(getTimestamp)
})

const onHandleRead = () => {
  emits('update', true)
}

const clickNotify = () => {
  emits('update', true)
  emits('close')
  getUrl()
}

const getUrl = () => {
  if (url.value === 'vehicleEdit') {
    useRouter().push({ name: 'trucker-id-vehicle-list', query: query.value || {} })
  }
  if (url.value === 'vendorCreate') {
    useRouter().push({ name: 'trucker-id-price-vendor', query: query.value || {} })
  }
  if (url.value === 'createPriceVendorByQuoteRequest') {
    useRouter().push({
      name: 'trucker-id-price-vendor-cooperatorId-view',
      params: { cooperatorId: query.value?.priceVendorId as string }
    })
  }
  if (url.value === 'orderDetail') {
    useRouter().push({ name: 'trucker-id-order', query: query.value || {} })
  }

  if (url.value === 'costOrder') {
    useRouter().push({ name: 'trucker-id-cost' })
  }
}
</script>
